import { ActionCreatorWithoutPayload } from "@reduxjs/toolkit";
import { AppDispatch } from "../../ReduxToolkit/Store";
import { dispatchMultiple } from "./dispatchMultiple";

/**
 * Utility function to clear multiple Redux messages + run a callback
 *
 * @param dispatch AppDispatch function
 * @param actions Array of Redux clear actions (no payload)
 * @param callback Optional function to run after dispatching clears
 */
export const clearReduxMessages = (
  dispatch: AppDispatch,
  actions: ActionCreatorWithoutPayload[],
  callback?: () => void
) => {
  dispatchMultiple(dispatch, actions, callback);
};
